import {MUTATION_KEYS} from '@/queryClient'
import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {httpVerifyAccountEmail, HttpVerifyAccountEmailOptions} from './account.http'

export const useVerifyAccountEmail = (promiseArgs: HttpVerifyAccountEmailOptions, options?: UseMutationOptions) =>
    useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.VERIFY_EMAIL_TOKEN],
        mutationFn: () => httpVerifyAccountEmail(promiseArgs)
    })
